import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { ListItemText } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router';

import { menusSlice } from '»components/Menus/_menus.slice';
import {
  getActiveMenuItemSelector,
  getActiveNavigationMenuItemSelector,
  getMainMenu,
} from '»components/Menus/menus.selectors';
import {
  FontAwesomeIconMobileStyled,
  ListItemIconMobileStyled,
  RootListItemButtonMobileStyled,
} from '»components/Menus/Mobile/Menu.mobile.styles';
import { useIsAbleToProceed } from '»utils/customHooks/useIsAbleToProceed';

export const WalletMenuItemMobile = () => {
  const dispatch = useDispatch();

  const activeMenuItem = useSelector(getActiveMenuItemSelector);
  const activeNavigationMenuItem = useSelector(
    getActiveNavigationMenuItemSelector,
  );
  const mainMenu = useSelector(getMainMenu);

  const available = mainMenu.some(
    (menuOption) => menuOption.optionId === 'TRLT_PORTFOLIO',
  );

  const { isAbleToProceed } = useIsAbleToProceed();

  const OPTION_ID = 'WALLET';

  const handleClickLeafMenu = (event, menuItem) => {
    isAbleToProceed(event, () => {
      dispatch(
        menusSlice.actions.setActiveMenuItem({ activeMenuItem: menuItem }),
      );
      dispatch(
        menusSlice.actions.setActiveNavigationMenuItem({
          activeNavigationMenuItem: '',
        }),
      );
    });
  };

  if (!available) return null;

  return (
    <RootListItemButtonMobileStyled
      onClick={(event) => handleClickLeafMenu(event, OPTION_ID)}
      component={NavLink}
      to="/Wallet"
      selected={activeMenuItem?.includes(OPTION_ID)}
      opened={activeNavigationMenuItem.includes(OPTION_ID)}
      isSubMenuPopup={activeNavigationMenuItem !== ''}
      id="btnMenuPortfolio"
    >
      <ListItemIconMobileStyled>
        <FontAwesomeIconMobileStyled
          icon={faWallet}
          selected={activeMenuItem?.includes(OPTION_ID)}
        />
      </ListItemIconMobileStyled>
      <ListItemText primary={<FormattedMessage id="TRLT_UI-PORTFOLIO" />} />
    </RootListItemButtonMobileStyled>
  );
};
WalletMenuItemMobile.propTypes = {
  available: PropTypes.bool,
  activeMenuItem: PropTypes.string,
  activeNavigationMenuItem: PropTypes.string,
  setActiveMenuItem: PropTypes.func,
  setActiveNavigationMenuItem: PropTypes.func,
};
